export const INCREMENT_PAGE = 'INCREMENT_PAGE'
export const SET_LOADING = 'SET_LOADING'
export const SET_DONE = 'SET_DONE'
export const SET_TOTAL_PAGES = 'SET_TOTAL_PAGES'
export const SET_LIST = 'SET_LIST'
export const SET_SEARCH_VALUE = 'SET_SEARCH_VALUE'
export const SET_CATEGORIA_ID = 'SET_CATEGORIA_ID'
export const SET_APPLIED_FILTERS = 'SET_APPLIED_FILTERS'
export const SET_PAGE = 'SET_PAGE'